import React from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import { OSCAR_INVITE_2026 } from '../../config/constants';
import './AboutPage.css';

const AboutPage = () => {
  const { settings } = useSettings();

  const formatPartyDate = () => {
    if (!settings?.partyStartDate) return null;
    const date = new Date(settings.partyStartDate);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'America/Los_Angeles'
    });
  };

  const formatPartyTime = () => {
    if (!settings?.partyStartDate) return null;
    const date = new Date(settings.partyStartDate);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'short'
    });
  };

  const formatBallotDeadline = () => {
    if (!settings?.ballotSubmissionDeadline) return null;
    const date = new Date(settings.ballotSubmissionDeadline);
    if (isNaN(date.getTime())) return null;
    return date.toLocaleString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'short'
    });
  };

  const partyDate = formatPartyDate();
  const partyTime = formatPartyTime();
  const ballotDeadline = formatBallotDeadline();

  return (
    <div className="about-page">
      <div className="about-container">
        <header className="about-header">
          <h1 className="leaderboard-title">About</h1>
          <p className="leaderboard-subtitle">
            Everything you need to know before showtime.
          </p>
        </header>

        <div className="about-content">
          <section className="about-section">
            <h2>Welcome to the {settings?.partyName || 'Martin-Resnick Oscar Party'}!</h2>
            <p>
              Welcome to our Oscar night party. We celebrate the Academy Awards together,
              make predictions, and follow the results live throughout the ceremony.
              It is a fun night of movies, competition, and bragging rights.
            </p>
          </section>

          <section className="about-section about-section--participate">
            <h2>Rules are Simple</h2>
            <div className="about-rules-list" role="list" aria-label="Participation rules">
              <div className="about-rules-list__item" role="listitem">
                Submit your ballot before the deadline.
              </div>
              <div className="about-rules-list__item" role="listitem">
                Bring <strong>$10 cash</strong> for a valid ballot submission.
              </div>
              <div className="about-rules-list__item" role="listitem">
                <strong>You must be present to win!!</strong>
              </div>
            </div>
          </section>

          <section className="about-section about-section--accent">
            <h2>Party Details</h2>
            <div className="about-details-lines" aria-label="Party details">
              <p className="about-details-line">
                <span>
                  Showtime:{' '}
                  <strong>{partyDate && partyTime ? `${partyDate} at ${partyTime}` : 'TBD'}</strong>
                </span>{' '}
                <span>
                  (Pregame: <strong>{OSCAR_INVITE_2026?.pregameTime || 'TBD'}</strong>)
                </span>
              </p>
              <p className="about-details-line">
                <span>
                  Ballot Submission Deadline: <strong>{ballotDeadline || 'TBD'}</strong>
                </span>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
